import React, { useState } from 'react';
import Pie from '../charts/Pie';
import DelayRender from '../DelayRender';
import useMetronome from '../utility/useMetronome';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import { translate } from '../utility/functions';

const Totals = ({ ...props }) => {

    const [data, setData] = useState([]);
    const [fetchData, setFetchData] = useState(5);

    useMetronome(() => {
        if (fetchData > 0) {
            setFetchData(fetchData - 1)
            HamQuest.get(QuestRoute.dashboard.totals)
                .then(res => setData(res))
                .catch(ex => console.error(ex))
        }
    }, 60000)

    const chartProps = {
        chartData: data.map(e => e.totalCount),
        labels: data.map(e => translate(e.label)),
        labelPos: 'bottom'
    }


    return (
        <DelayRender>
            <Pie chartProps={chartProps} />
        </DelayRender>
    );
}

export default Totals;